import { render, staticRenderFns } from "./EventSelectorEventSelect.vue?vue&type=template&id=1059bc1d&scoped=true&"
import script from "./EventSelectorEventSelect.vue?vue&type=script&lang=js&"
export * from "./EventSelectorEventSelect.vue?vue&type=script&lang=js&"
import style0 from "./EventSelectorEventSelect.vue?vue&type=style&index=0&id=1059bc1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1059bc1d",
  null
  
)

export default component.exports